import { scoreApi } from "@hub/apis/score/scoreApi";
import { queryOptions } from "@tanstack/react-query";
import type { APIResponse, NegativeInfo } from "./types";

const fetchNegativeData = async () => {
	const endpoint = "/v1/finder/negative";
	const { data } = await scoreApi.get<APIResponse<NegativeInfo[]>>(endpoint);
	if (!data.data) {
		throw new Error("Failed to fetch negative data");
	}
	return data.data;
};

export const scoreQueries = {
	_all: [{ scope: "hub-score" }] as const,

	negative: () =>
		queryOptions({
			queryKey: [{ ...scoreQueries._all, entity: "negative" }] as const,
			queryFn: fetchNegativeData,
		}),
};
